import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {
    Button,
    CircularProgress,
    Link,
    Stack,
    Typography,
} from "@mui/material";
import {grey} from "@mui/material/colors";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {useSubscribeNewsLetter} from "../../../../hooks/useSubscribeNewsLetter";
import {useMutation} from "react-query";

const NewsletterSubscription: React.FC = () => {
    const {t} = useTranslation();
    const [email, setEmail] = useState("");
    const [termsAccepted, setTermsAccepted] = useState("");
    const [termsAcceptedError, setTermsAcceptedError] = useState(false);

    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    // const [errorMessage, setErrorMessage] = useState("");

    const {mutate, isLoading}: any = useMutation(useSubscribeNewsLetter, {
        onSuccess: () => {
            setIsError(false);
            setIsSuccess(true);
            setEmail("");
        },
        onError: (error: any) => {
            setIsSuccess(false);
            setIsError(true);
            // setErrorMessage(error.response.data?.errors[0]?.title);
        },
    });

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!termsAccepted) {
            setTermsAcceptedError(true);

            return;
        }
        if (email) {
            mutate({
                data: {
                    type: "newsletter-subscriptions",
                    attributes: {
                        email,
                    },
                },
            });
        }
    };

    return (
        <section className="home-newsletter">
            <div className="home-newsletter__content">
                <Stack spacing={4}>
                    <Typography variant="h4">{t("HOME_NEWSLETTER_TITLE")}</Typography>
                    <Typography variant="subtitle1" color={grey[600]}>
                        {t("HOME_NEWSLETTER_TEXT")}
                    </Typography>
                    {isError && (
                        <div
                            style={{
                                backgroundColor: "rgb(255, 0,0,0.2)",
                                padding: "12px 30px",
                                border: "1px solid rgb(255, 0,0,0.6)",
                                borderRadius: 4,
                                alignSelf: "center",
                            }}
                        >
                            <Typography color="rgb(255, 0,0,0.6)" variant="h6">
                                Ova elektronička adresa je već prijavljena na listu
                            </Typography>
                        </div>
                    )}
                    {termsAcceptedError && (
                        <div
                            style={{
                                backgroundColor: "rgb(255, 0,0,0.2)",
                                padding: "12px 30px",
                                border: "1px solid rgb(255, 0,0,0.6)",
                                borderRadius: 4,
                                alignSelf: "center",
                            }}
                        >
                            <Typography color="rgb(255, 0,0,0.6)" variant="h6">
                                {t('HOME_NEWSLETTER_TERMS_NOT_ACCEPTED')}
                            </Typography>
                        </div>
                    )}
                    {isSuccess ? (
                        <div
                            style={{
                                backgroundColor: "rgb(150, 187, 85, 0.2)",
                                padding: "12px 30px",
                                border: "1px solid rgb(150, 187, 85, 0.6)",
                                borderRadius: 4,
                                alignSelf: "center",
                            }}
                        >
                            <Typography color="secondary" variant="h6">
                                Uspješno ste se pretplatili na listu
                            </Typography>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="home-newsletter__form">
                            <input
                                type="email"
                                placeholder={t("HOME_NEWSLETTER_INPUT_PLACEHOLDER")}
                                className="home-newsletter__input"
                                required
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <Button type="submit" className="home-newsletter__button">
                                {isLoading ? <CircularProgress/> : t("HOME_NEWSLETTER_BUTTON")}
                            </Button>
                        </form>
                    )}
                    <Stack
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        spacing={1}
                        sx={{
                            ":hover": {
                                textDecoration: "underline",
                            },
                        }}
                    >
                        <input type="checkbox" id="terms" name="terms" value={termsAccepted} onClick={(e) => {
                            setTermsAccepted(termsAccepted ? '' : 'on');
                            setTermsAcceptedError(false);
                        }}/>
                        <LockOutlinedIcon fontSize="small"/>
                        <Link href="/uvjeti-koristenja" underline="none">
                            <a
                                href="/uvijeti-koristenja"
                                style={{
                                    color: grey[600],
                                    textDecoration: "none",
                                }}
                            >
                                <Typography>{t("HOME_NEWSLETTER_LINK")}</Typography>
                            </a>
                        </Link>
                    </Stack>
                </Stack>
            </div>
        </section>
    )
        ;
};

export default NewsletterSubscription;
